import React from 'react';
import get from 'lodash.get';
import { defineMessages, FormattedMessage } from 'react-intl';
import { of } from 'rxjs';

import { NOTIFICATION_DURATIONS, NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_INFO } from 'ui-components/services/notification-service';

import { DocumentType } from '../../../enums/document-type';
import * as ConnectActions from '../../../store/shipstation-connect/ss-connect.actions';

const messages = defineMessages({
  printingPurchaseOrderSuccessTitle: {
    description: 'Printing Purchase Order Success Title',
    defaultMessage: 'Printing {docCount, plural,=0 {Purchase Order} one {Purchase Order} other {Purchase Orders}}...',
    id: '1ANuV9',
  },
  printingPurchaseOrderSuccessContent: {
    description: 'Printing Purchase Order Success Content',
    defaultMessage: '{docCount, plural,=0 {Purchase Order} one {Purchase Order} other {Purchase Orders}} sent to {printerName}.',
    id: 'sXSpWg',
  },
  downloadPurchaseOrderStartedTitle: {
    description: 'Download Purchase Order Started Title',
    defaultMessage: 'Downloading {docCount, plural,=0 {Purchase Order} one {Purchase Order} other {Purchase Orders}}...',
    id: 'yebsNg',
  },
  downloadPurchaseOrderStartedContent: {
    description: 'Download Purchase Order Started Content',
    defaultMessage: '{docCount, plural,=0 {Purchase Order} one {Purchase Order} other {Purchase Orders}} Download Started.',
    id: 'aBqDze',
  },
  downloadPurchaseOrderCompletedTitle: {
    description: 'Download Purchase Order Completed Title',
    defaultMessage: 'Downloading {docCount, plural,=0 {Purchase Order} one {Purchase Order} other {Purchase Orders}}...',
    id: 'sxpX+x',
  },
  downloadPurchaseOrderCompletedContent: {
    description: 'Download Purchase Order Completed Content',
    defaultMessage: '{docCount, plural,=0 {Purchase Order} one {Purchase Order} other {Purchase Orders}} Download Completed.',
    id: '5vwnYt',
  },
  asyncPrintPurchaseOrderStartedContent: {
    description: 'Notification message shown when generating a pick list',
    defaultMessage: 'We are generating your {docCount, plural,=0 {Purchase Order} one {Purchase Order} other {Purchase Orders}}.',
    id: 'Tgpo5i',
  },
  asyncPrintPurchaseOrderFailedContent: {
    description: 'Notification message shown when generating a pick list fails',
    defaultMessage:
      'Failed to generate {docCount, plural,=0 {Purchase Order} one {Purchase Order} other {Purchase Orders}}. Please try again.',
    id: 'XWcz41',
  },
});

export const purchaseOrder = {
  id: DocumentType.PurchaseOrder.identifier,

  getDownloadStartedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadPurchaseOrderStartedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadPurchaseOrderStartedContent} values={{ docCount }} />,
  }),

  getDownloadCompletedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadPurchaseOrderCompletedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadPurchaseOrderCompletedContent} values={{ docCount }} />,
  }),

  getPrintedSuccessNotificationProps: (docCount, printerName) => ({
    title: <FormattedMessage {...messages.printingPurchaseOrderSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.printingPurchaseOrderSuccessContent} values={{ docCount, printerName }} />,
  }),

  getAsyncPrintStartedNotificationProps: (docCount) => ({
    title: <FormattedMessage {...messages.printingPurchaseOrderSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.asyncPrintPurchaseOrderStartedContent} values={{ docCount }} />,
    notificationType: NOTIFICATION_TYPE_INFO,
  }),

  getAsyncPrintFailedNotificationProps: (docCount) => ({
    title: <FormattedMessage {...messages.printingPurchaseOrderSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.asyncPrintPurchaseOrderFailedContent} values={{ docCount }} />,
    notificationType: NOTIFICATION_TYPE_ERROR,
    duration: NOTIFICATION_DURATIONS.MEDIUM,
  }),

  getPrintedSuccessObservable: (printJob) => {
    const printJobRequestId = get(printJob, 'requestId');
    return of(ConnectActions.printDocumentComplete(printJobRequestId));
  },
};
